import React from 'react';
import { CheckCircle2 } from 'lucide-react';

const ABOUT_IMAGE_SRC = "https://customer-assets.emergentagent.com/job_1ed5769b-afbd-42df-b2a9-d4f9537af194/artifacts/yxab8u9i_IMG_0928.jpeg";

const bullets = [
  "Personalized service suited to you",
  "Clear communication, no jargon",
  "Support even after the site goes live",
];

const AboutImage = () => (
  <div className="w-full md:w-1/2">
    <div className="relative aspect-square md:aspect-[4/5] bg-[var(--bg-card)] border border-[var(--border-medium)] p-4">
      <div className="w-full h-full bg-[var(--bg-page)] flex items-center justify-center overflow-hidden grayscale hover:grayscale-0 transition-all duration-500">
        <img src={ABOUT_IMAGE_SRC} alt="About Me" className="w-full h-full object-cover" />
      </div>
      <div className="absolute -top-4 -right-4 w-24 h-24 border-t-2 border-r-2 border-[var(--brand-primary)]" />
      <div className="absolute -bottom-4 -left-4 w-24 h-24 border-b-2 border-l-2 border-[var(--brand-secondary)]" />
    </div>
  </div>
);

const AboutCopy = () => (
  <div className="w-full md:w-1/2">
    <h2 className="heading-3 mb-8">About Me</h2>
    <h3 className="text-3xl font-bold text-[var(--text-primary)] mb-6">
      Reliable. Professional. <br />Customer-First.
    </h3>
    <div className="space-y-6 text-[var(--text-secondary)] text-lg leading-relaxed">
      <p>I'm a freelance web developer dedicated to helping small businesses establish a strong online presence. I understand that for many business owners, the digital world can be overwhelming.</p>
      <p>My goal is to make the process simple and stress-free. I don't just build websites; I build tools that help your business succeed.</p>
      <div className="flex flex-col gap-4 mt-8">
        {bullets.map((text) => (
          <div key={text} className="flex items-center gap-3">
            <CheckCircle2 className="text-[var(--brand-primary)]" />
            <span>{text}</span>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const AboutSection = () => (
  <section id="about" className="py-20 border-y border-[var(--border-medium)] bg-[var(--bg-card)]/30">
    <div className="container mx-auto px-6">
      <div className="flex flex-col md:flex-row gap-16 items-center">
        <AboutImage />
        <AboutCopy />
      </div>
    </div>
  </section>
);
